import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../servicios/auth.service';
import { AngularFireMessaging } from '@angular/fire/messaging';

import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
  items = [
  ];

  es_admin: boolean;
  host: boolean;
  usuario: string;

  public fecha: string;
  public hora: string;

  constructor(
    private router: Router,
    private authService: AuthService,
    private messaging: AngularFireMessaging,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    setInterval(() => {
      this.getfecha();
    },1000);

    this.authService.getUsuario().subscribe(user => {
      this.usuario = user?.email;
      this.es_admin = user?.email ? true : false;
    });

    // Registrar el sitio para notificaciones push.
    this.messaging.messages.subscribe((payload) => {
      console.log('Message received. ', payload);
    });
  }


  logout() {
    this.authService.doLogout().pipe(
      finalize(() => {
        this.router.navigate(['']);
      })
    ).subscribe();
  }

  getfecha() {
    const monthName = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    const now = new Date();

    const day = now.getDate();
    const mount = now.getMonth();
    const year = now.getFullYear();
    const hours = now.getHours();
    const min = now.getMinutes();
    const sec = now.getSeconds();

    const mouthShow = monthName[mount];
    // Estructurando fecha
    this.fecha = `${day} de ${mouthShow} de ${year}`;

    const hourShow = (hours > 12) ? (hours - 12) : hours;
    const minShow = (min > 10) ? min : `0${min}`;
    const secShow = (sec > 10) ? sec : `0${sec}`;
    const ampm = (hours > 12) ? "PM" : "AM";

    this.hora =  `${hourShow}:${minShow}:${secShow} ${ampm}`;
  }

  // Click img Powered
  redirect() {
    if(!this.es_admin) {
      window.open('https://i-strategies.tech/','_blank');
    }
  }

}
